import { i18n } from 'next-i18next'
import type { CookieConsentConfig, Translation } from 'vanilla-cookieconsent'
import { availableLanguages } from 'domain/models/Translations/Translation'

export const AD_STORAGE = 'ad_storage'
export const AD_USER_DATA = 'ad_user_data'
export const AD_PERSONALIZATION = 'ad_personalization'
export const ANALYTICS_STORAGE = 'analytics_storage'

export const pluginConfig = (
  translations: Record<availableLanguages, Translation>,
  updateGtagConsent: () => void,
  logConsent: () => void
): CookieConsentConfig => ({
  guiOptions: {
    consentModal: {
      position: 'bottom left'
    }
  },
  onFirstConsent: () => {
    updateGtagConsent()
    logConsent()
  },
  onConsent: updateGtagConsent,
  onChange: () => {
    updateGtagConsent()
    logConsent()
  },
  categories: {
    [AD_STORAGE]: {
      autoClear: {
        cookies: [
          {
            name: /^(_ga)/
          },
          {
            name: '_gid'
          }
        ]
      }
      // See: https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
    },
    [AD_USER_DATA]: {},
    [AD_PERSONALIZATION]: {},
    [ANALYTICS_STORAGE]: {}
  },
  language: {
    default: i18n?.language ?? 'fr',
    translations
  }
})
